export const studentMajors = [
  { value: 'ipol', label: 'IPOL' },
  { value: 'culp', label: 'CULP' },
  { value: 'ieco', label: 'IECO' },
  { value: 'ihist', label: 'IHIST' },
];
